import React from 'react';
import reco from '../images/icon-brand-recognition.svg';
import record from '../images/icon-detailed-records.svg';
import custo from '../images/icon-fully-customizable.svg';

function Box() {
    return (
        <div >
            <div className='bg-[#ffffff] sm:top-[68rem] h-[18rem] sm:left-[8rem] rounded-md top-[72rem] absolute left-[.60rem] w-[22rem]'>
                <div className='bg-[#3a3053] sm:left-[2rem] absolute top-[-2.50rem] left-[40%] flex items-center justify-center rounded-full h-[5rem] w-[5rem]'>
                    <img src={reco} className='h-[2.50rem]' alt='reco-icon' />

                </div>
                <h2 className='text-3xl sm:left-8  sm:text-2xl absolute left-[3.40rem] top-[4.50rem] font-medium'>Brand Recognition</h2>
                <p className='text-lg top-[8rem] sm:hidden text-[rgba(0,0,0,0.4)] text-center absolute left-[2rem] '>Boost your brand recognition with <br /> each click.Generic links don't <br /> mean a an a thing.Branded links help <br /> instil confidence in your content.</p>
                <p className='sm:text-lg top-[8rem] text-[0px]  text-[rgba(0,0,0,0.4)] text-left absolute left-[2rem] '>Boost your brand recognition with <br /> each click.Generic links don't  mean a <br /> an a thing.Branded links help  instil <br /> confidence in your content.</p>

            </div>

            <div className='bg-[#ffffff] sm:left-[32rem] sm:top-[72rem] h-[18rem] rounded-md top-[96rem] absolute left-[.60rem] w-[22rem]'>
                <div className='bg-[#3a3053] sm:left-[2rem] absolute top-[-2.50rem] left-[40%] flex items-center justify-center rounded-full h-[5rem] w-[5rem]'>
                    <img src={record} className='h-[2.50rem]' alt='reco-icon' />

                </div>
                <h2 className='text-3xl sm:left-8  sm:text-2xl absolute left-[3.40rem] top-[4.50rem] font-medium'>Detailed Records</h2>
                <p className='text-lg sm:hidden top-[8rem] text-[rgba(0,0,0,0.4)] text-center absolute left-[2.50rem] '>Gain insights into who is clicking <br /> your links.Knowing when and <br /> where people engage with your <br /> content helps inform better <br /> decisions.</p>
                <p className='sm:text-lg top-[8rem] text-[0px]  text-[rgba(0,0,0,0.4)] text-left absolute left-[2rem] '>Gain insights into who is clicking  your <br /> links.Knowing when and  where <br /> people engage with your content <br /> helps inform better  decisions.</p>

            </div>

            <div className='bg-[#ffffff] sm:top-[76rem] sm:left-[56rem] h-[18rem]  rounded-md top-[120rem] absolute left-[.60rem] w-[22rem]'>
                <div className='bg-[#3a3053] sm:left-[2rem] absolute top-[-2.50rem] left-[40%] flex items-center justify-center rounded-full h-[5rem] w-[5rem]'>
                    <img src={custo} className='h-[2.50rem] ' alt='reco-icon' />

                </div>
                <h2 className='text-3xl sm:left-8  sm:text-2xl absolute left-[3.40rem] top-[4.50rem] font-medium'>Fully Customizable</h2>
                <p className='text-lg sm:hidden top-[8rem] text-[rgba(0,0,0,0.4)] text-center absolute left-[2.80rem] '>Improve brand awareness and <br /> content discoverability through <br /> customizable links,supercharging <br /> audience engagement.</p>
                <p className='sm:text-lg top-[8rem] text-[0px]  text-[rgba(0,0,0,0.4)] text-left absolute left-[2rem] '>Improve brand awareness and <br /> content discoverability through <br /> customizable links,supercharging <br /> audience engagement.</p>

            </div>


        </div>
    )
}

export default Box